import { css } from "@emotion/react";

const Bluray: React.FC = () => {
  return (
    <div css={mainStyle} id="bluray">
      <div css={contentsWrapper}>
        <img
          src={process.env.REACT_APP_ASSET_BASE_PATH + "/img/bluray-txt.png"}
          css={txtImgStyle}
        />
        <div css={reserveLinkStyle}>
          <a
            href="https://www.tc-ent.co.jp/products/search?keyword=%E9%9F%B3%E6%A5%BD%E6%9C%97%E8%AA%AD%E5%8A%87+%E3%82%A2%E3%82%B7%E3%82%AC%E3%83%BC%E3%83%AB"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={
                process.env.REACT_APP_ASSET_BASE_PATH + "/img/bluray-btn.png"
              }
              alt="Blu-ray予約"
              width="120"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

const primaryColor = "#DD6B74";

const mainStyle = css`
  width: 100%;
  background-color: rgba(255, 255, 255);
  display: flex;
  justify-content: center;
  background-color: ${primaryColor};
`;

const contentsWrapper = css`
  width: 100%;
  max-width: 500px;
  padding: 20px 20px 10px;
`;

const txtImgStyle = css`
  width: 280px;
  height: auto;
`;

const reserveLinkStyle = css`
  z-index: 1;
  position: relative;
  margin-top: 10px;
  display: flex;
  justify-content: center;
`;

export default Bluray;
